module.exports = __webpack_public_path__ + "img/lige_pink.8c7c1c88.png";